import React from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { push } from 'react-router-redux'
import { history } from '../store'
import AppTimeHeader from '../containers/AppTimeHeader'
import { withNamespaces } from "react-i18next"
import StepBarTime from '../components/StepBarTime'
import { LayoutGrid, CreditCard, Smartphone, LockKeyhole, RefreshCw, Timer } from 'lucide-react'

class TimeSelectorView extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      forwardScreen: false
    }
  }

  getButtonStyle() {
    const { qrData } = this.props;
    const buttonColor1 = qrData?.headerConfig?.buttonColor1 || '#01315f';
    const buttonColor2 = qrData?.headerConfig?.buttonColor2 || '#067ddb';
    const buttonText = qrData?.headerConfig?.buttonText || '#ffffff';

    return {
      background: `linear-gradient(135deg, ${buttonColor1}, ${buttonColor2})`,
      color: buttonText,
      border: 'none'
    };
  }

  getPrimaryColor() {
    const { qrData } = this.props;
    return qrData?.headerConfig?.primaryColor || '#01315f';
  }

  goToZones = () => {
    const { id } = this.props.match.params;
    this.setState({ forwardScreen: true }, () => {
      history.push(`/zoneSelectorTimeView/${id}`, { qrMode: 5 });
    });
  }

  goToAccess = () => {
    const { id } = this.props.match.params;
    this.setState({ forwardScreen: true }, () => {
      history.push(`/timeAccessView/${id}`, { qrMode: 5 });
    });
  }

  render() {
    const { t } = this.props;
    const buttonStyle = this.getButtonStyle();
    const primaryColor = this.getPrimaryColor();
    const iconsColor = this.props.qrData?.headerConfig?.iconsColor || primaryColor || '#01315f';
    const textPrimary = this.props.qrData?.headerConfig?.textPrimary || primaryColor || '#01315f';

    const steps = [
      { icon: <CreditCard size={20} color={iconsColor} />, title: t('Reserva tu taquilla'), desc: t('Elige tamaño y taquilla disponible.') },
      { icon: <Timer size={20} color={iconsColor} />, title: t('Selecciona el tiempo'), desc: t('Elige la duración del alquiler.') },
      { icon: <Smartphone size={20} color={iconsColor} />, title: t('Recibes tus credenciales'), desc: t('Te enviamos un email con tu código de acceso.') },
      { icon: <LockKeyhole size={20} color={iconsColor} />, title: t('Abre tu taquilla'), desc: t('Usa “Abrir taquilla alquilada” con tu teléfono y código.') },
      { icon: <RefreshCw size={20} color={iconsColor} />, title: t('Amplía el tiempo'), desc: t('Desde la pantalla de tu taquilla abierta puedes comprar más tiempo.') },
    ];

    return (
      <div className="timeBackground">
        <AppTimeHeader />
        <div className="time-page-wrap">
          <div className="time-content time-locker-selector-wide" style={{ paddingBottom: 24 }}>

            {/* ── New-style header ── */}
            <div className="time-page-header">
              <div className="time-page-header-icon" style={buttonStyle}>
                <LayoutGrid size={24} strokeWidth={2} />
              </div>
              <div className="time-page-header-text">
                <h2>{t('¿Qué deseas hacer?')}</h2>
                <p>{t('Selecciona una opción para continuar')}</p>
              </div>
            </div>

            {/* ── Action buttons ── */}
            <div className="time-selector-buttons" style={{ marginBottom: 20 }}>
              <button className="time-selector-btn time-btn-primary" style={buttonStyle} onClick={this.goToZones}>
                <div className="time-btn-icon-wrap">
                  <img src="/images/lockerClosed.png" alt="Alquilar" className="time-btn-icon" />
                </div>
                <div className="time-btn-text">
                  <h4>{t('ALQUILAR TAQUILLA')}</h4>
                  <p>{t('Alquila una nueva taquilla por tiempo')}</p>
                </div>
              </button>

              <button className="time-selector-btn time-btn-secondary" onClick={this.goToAccess}>
                <div className="time-btn-icon-wrap">
                  <img src="/images/lockerOpen.png" alt="Abrir" className="time-btn-icon" />
                </div>
                <div className="time-btn-text">
                  <h4>{t('ABRIR TAQUILLA ALQUILADA')}</h4>
                  <p>{t('Accede a tu taquilla con tus credenciales')}</p>
                </div>
              </button>
            </div>

            {/* ── How it works card ── */}
            <div style={{
              background: 'white',
              borderRadius: 16,
              padding: '18px 20px',
              boxShadow: '0 2px 12px rgba(0,0,0,0.07)',
              borderLeft: `4px solid ${iconsColor}`,
            }}>
              <p style={{ margin: '0 0 14px', fontWeight: 700, fontSize: '0.9rem', color: textPrimary, textTransform: 'uppercase', letterSpacing: '0.4px' }}>
                {t('¿Cómo funciona?')}
              </p>
              <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
                {steps.map((s, i) => (
                  <div key={i} style={{ display: 'flex', alignItems: 'flex-start', gap: 12 }}>
                    <div style={{
                      flexShrink: 0, width: 36, height: 36, borderRadius: 10,
                      background: `${iconsColor}14`,
                      display: 'flex', alignItems: 'center', justifyContent: 'center',
                    }}>
                      {s.icon}
                    </div>
                    <div style={{ paddingTop: 2 }}>
                      <div style={{ fontWeight: 700, fontSize: '0.85rem', color: '#1a1a2e', lineHeight: 1.2, marginBottom: 2 }}>{s.title}</div>
                      <div style={{ fontSize: '0.78rem', color: '#888', lineHeight: 1.4 }}>{s.desc}</div>
                    </div>
                  </div>
                ))}
              </div>
            </div>

          </div>
        </div>
        <StepBarTime step={0} />
      </div>
    )
  }
}

const mapStateToProps = state => ({
  auth: true,
  qrData: state.qrs.qr
})

const mapDispatchToProps = dispatch => ({
  push: bindActionCreators(push, dispatch)
})

export default withNamespaces()(connect(mapStateToProps, mapDispatchToProps)(TimeSelectorView));
